// Compatibility shim: replaces packery/dist/packery.pkgd (a pre-bundled UMD
// file that can't be processed by rspack) with the regular packery package
// wired up through jquery-bridget, matching the jQuery plugin API used
// throughout the codebase ($el.packery({...}), $el.packery('method')).
import Packery from 'packery'
import jQueryBridget from 'jquery-bridget'
import $ from 'jquery'

jQueryBridget('packery', Packery, $)
